import { Component, OnInit } from "@angular/core";
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { default as swal } from "sweetalert2";

import * as XLSX from "xlsx";
import { PagerService } from "../services/pager.service";

type AOA = any[][];

declare var $: any;

@Component({
  selector: "app-mailer",
  templateUrl: "./mailer.component.html",
  styleUrls: ["./mailer.component.css"],
})
export class MailerComponent implements OnInit {
  public href: string = "";
  public add_mailer = false;
  public list_mailer = false;

  mailerList;

  mailerForm;
  projects;
  categories;
  approvers;
  approver_msg;
  approver_delete_msg;

  templates;
  submitted;
  boolShowDownloadLink;

  boolLoading = false;
  boolSuccess = true;

  /* project: string; */

  approver_email;
  project_list;
  category_list;
  template_list;
  /* excel handling class variable */
  data: AOA = []; //[ [1, 2], [3, 4] ];
  wopts: XLSX.WritingOptions = { bookType: "xlsx", type: "array" };
  fileName: string = "SheetJS.xlsx";
  /* excel handling class var ends here */

  constructor(
    private fb: FormBuilder,
    private router: Router,
    public authService: AuthService,
    public pagerService:PagerService
  ) {
    this.add_mailer = false;
    this.list_mailer = false;
  }

  ngOnInit() {
    this.href = this.router.url;
    console.log(this.router.url);
    this.getProjects();

    if (this.href == "/mailer/add") {
      this.add_mailer = true;
      this.list_mailer = false;
     
      //this.getCategories();
    } else {
      this.add_mailer = false;
      this.list_mailer = true;
      
    }

    this.submitted = false;
    this.mailerForm = this.fb.group({
      project: this.fb.control("", Validators.required),
      category: this.fb.control("", Validators.required),
      file_data: this.fb.control("", Validators.required),
    });

    
  }

  addMailer(args = {}) {
    this.authService.addMailer(this.mailerForm.value).subscribe((data: any) => {
      if (data.error) {
        swal("OOPs!", data.message, "error");
      } else {
        swal("Success", data.message, "success");
        this.router.navigate(["./mailer"]);
      }
    });
  }

  
  //************* paging */
  public g_cat_id:any = '';
  public ofcPage: any = '';
  public ofcount: any = '';
  public pager:any = {};
  public pagedItems :any = [];

  ofsetPage(page: number,cat_id='') {
    this.ofcPage = page;
    this.listMailer(cat_id).then(count => {
      this.ofcount = count;
      
      this.pager = this.pagerService.getPager(Number(count), page, 10);
      this.pagedItems = this.mailerList;
      console.log('pagedItems :: ', this.pagedItems);
      console.log('this.pager :: ', this.pager);

    }).catch(err => { console.log(err) });
  }

  getListWrapFn(cat_id){
    // this.listMailer(cat_id) 
    this.g_cat_id = cat_id
    this.ofsetPage(1,cat_id) 
  }

  listMailer(cat_id) {
    this.listTemplate();
    let obj = {
      page_no:this.ofcPage,
      page_size:10
    };

    return new Promise(resolve => {
      this.authService.listMailer({category : cat_id,...obj}).subscribe((data: any) => {
        if (data.error) {        
          console.log(data.error);
        } else {           
          this.mailerList = data.data;
          resolve(data.count);
        }
      });
    })
  }

  getProjects(args = {}) {
    this.authService.getProjects(args).subscribe((data: any) => {
      if (data.error) {        
        console.log(data.error);        
      } else {
        this.projects = data.data;    
        this.mailerForm.get("category").setValue(this.projects[0]);
      }
    });
  }

  getCategories(project_id) {
    if (project_id && project_id != "") {
     // this.getApprovers();

      this.authService
        .listCategory({ project: project_id })
        .subscribe((data: any) => {
          if (data.error) {
            console.log(data.error);
          } else {
            this.categories = data.data;           
            this.mailerForm.get("project").setValue(this.categories[0]);            
          }
        });
    } else {
      this.categories = [];
    }
    //return;
  }

  getApprovers() {
    let project_id = this.project_list;    
   if (project_id && project_id != "") {
   
      this.authService
        .listApprovers({ project_id: project_id })
        .subscribe((data: any) => {
          if (data.error) {
            console.log(data.error);
          } else {
            this.approvers = data.data;           
                    
          }
        });
    } else {
      alert("Please select project")     
      this.approvers = [];
      setTimeout(function(){
        closeDialog("viewApproverModal")
      },500)
      
      return;
    }
    //return;
  }


  addApprover() {
   this.approver_msg = '';
   if(!this.project_list){
    this.approver_msg = 'Project not selected' 
    var self = this;
    setTimeout(function(){
      self.approver_msg = ''
    },3000)
    return;
  }
    if(!this.approver_email){    
      return;
    }
    this.authService.addApprover({project_id:this.project_list,approver_email:this.approver_email}).subscribe((data: any) => {
      if (data.error) {
        swal("OOPs!", data.message, "error");
      } else {
        swal("Success", data.message, "success");
        this.approver_email = '';
        //this.router.navigate(["./mailer"]);
        closeDialog("addApproverModal")
      }
    });
  } 
  
  deleteApprover(id) {

  var txt;
  if (confirm("Would you like to proceed !")) {

    this.authService.deleteApprover({approver_id:id}).subscribe((data: any) => {
      if (data.error) {
        //swal("OOPs!", data.message, "error");
        this.approver_delete_msg = data.message;
      } else {
        //swal("Success", data.message, "success");
        this.getApprovers();
        this.approver_delete_msg = data.message;
        //this.router.navigate(["./mailer"]);
       
      }
    });
  } else {
   return;
  }

    this.approver_msg = '';
    if(!this.project_list){
     this.approver_msg = 'Project not selected' 
     var self = this;
     setTimeout(function(){
       self.approver_msg = ''
     },3000)
     return;
   }
     if(!this.approver_email){    
       return;
     }
     
   }

  //===========Excel handling goes here =======

  onFileChange(evt: any) {
    this.boolLoading = true;
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>evt.target;
    if (target.files.length !== 1) throw new Error("Cannot use multiple files");
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: "binary" });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      this.data = <AOA>XLSX.utils.sheet_to_json(ws, { header: 1 });

      this.boolLoading = false;
      /* console.log(this.data); */
    };
    reader.readAsBinaryString(target.files[0]);
  }

  export(): void {
    /* generate worksheet */
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(this.data);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }

  onSubmit() {
    this.submitted = true;  

    /* let data_obj = {
      project: this.projects[0]._id,
      file_data: this.data,
      category: this.categories[0]._id,
    }; */

    let project_id = this.project_list;
    let cat_id =  this.category_list;
    
    let req_obj = { file_data: this.data}
    if(project_id && project_id !=undefined){
      req_obj["project"] = project_id;
    }

    if(cat_id && cat_id !=undefined){
      req_obj["category"] = cat_id;
    }
    
    console.log("====requ_obj=========")
    console.log(req_obj);
    
    this.authService.addMailer(req_obj).subscribe((result: any) => {
      this.boolLoading = false;
      this.boolSuccess = true;

      if (!result.error) {
        swal("Success", "Imported Successfully", "success");
        const tmp_router = this.router;
        setTimeout(function () {
          closeDialog("myModal");
          tmp_router.navigate(['./mailer']);
        }, 1000);
      } else {
        swal("OOPs!", "An error occured while importing", "error");
      }
    });
  }

  listTemplate(){
    let project_id = this.project_list;
    let cat_id =  this.category_list;
    
    let req_obj = { file_data: this.data}
    if(project_id && project_id !=undefined){
      req_obj["project"] = project_id;
    }

    if(cat_id && cat_id !=undefined){
      req_obj["category"] = cat_id;
    }
    

    this.authService.listTemplate(req_obj).subscribe((res:any) =>{
      if(res.error){
        swal("Oops",res.message,"error");
        return
      }

      this.templates = res.data;
    })
  }
  

  testEmail(){   

    let project_id = this.project_list;
    let cat_id =  this.category_list;
    let template = this.template_list;
    let req_obj = {testing:"true"}
    if(project_id && project_id !=undefined){
      req_obj["project"] = project_id;
    }

    if(cat_id && cat_id !=undefined){
      req_obj["category"] = cat_id;
    }

    if(template && template !=undefined){
      req_obj["template"] = template;
    }

    
    this.authService.triggerMail(req_obj).subscribe((res:any) =>{
      if(res.error){
       swal("Oops!!",res.message,"error"); 
        return;
      }

     /*  console.log("===success");
      console.log(res); */

      swal("Success",res.message,"success"); 
      
    })

    return;
  }
 
  triggerMail(){  
    
    $("#triggerMailModal").modal("hide");

    let project_id = this.project_list;
    let cat_id =  this.category_list;
    let template = this.template_list;
    let req_obj = {}
    if(project_id && project_id !=undefined){
      req_obj["project"] = project_id;
    }

    if(cat_id && cat_id !=undefined){
      req_obj["category"] = cat_id;
    }

    if(template && template !=undefined){
      req_obj["template"] = template;
    }

    
    this.authService.triggerMail(req_obj).subscribe((res:any) =>{
      if(res.error){
       swal("Oops!!",res.message,"error"); 
        return;
      }

     /*  console.log("===success");
      console.log(res); */

      swal("Success",res.message,"success"); 
      
    })

    return;
  }

  
 
}


function closeDialog(selectr) { 
  //alert("==okkkk");
  $("#" + selectr).modal("hide");
}


// WEBPACK FOOTER //
// /home/lynkit/Downloads/staging-boltseal/boltseal/newsletter-client/src/app/mailer/mailer.component.ts